module.exports = __webpack_public_path__ + "img/map-page.7e6286d9.jpg";